import { PaymentsPaginatorInterface } from '../../models/payments.paginator.interface';

export interface PaymentsInterfaceState {
  payments: PaymentsPaginatorInterface;
}

export const initialPaymentsState: PaymentsInterfaceState = {
  payments: null
};
